// extracted by mini-css-extract-plugin
export default {"edit-report-filters-popup":"EditReportFiltersPopup_edit-report-filters-popup__NS-W+","popup-header":"EditReportFiltersPopup_popup-header__N+GTy"};